import React from 'react';

import Content from '@components/Dashboard/BenefitArea';

const BenefitArea: React.FC = () => {
  return <Content />;
};

export default BenefitArea;
